import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=fab970ba&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=fab970ba&prod&lang=scss"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=fab970ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab970ba",
  null
  
)

export default component.exports